export default {
  'common.loading': 'Loading…',
  'common.saving': 'Saving…',
  'common.cancel': 'Cancel',
  'common.remove': 'Remove',
  'common.close': 'Close',

  'app.account': 'Account',
  'app.homeAria': 'Danny Top — Home',
  'app.settings': 'Settings',
  'app.logout': 'Log out',
  // Guest landing (docs/guest-landing/SPEC.md)
  'guestLanding.eyebrow': 'Danny Top',
  'guestLanding.title': 'Investments under control',
  'guestLanding.description': 'Manage investments in one place: follow your capital, payouts and portfolio structure.',
  'guestLanding.createAccount': 'Create account',
  'guestLanding.hasAccount': 'Already have an account? Sign in',
  'guestLanding.feature.capital': 'Capital value and return',
  'guestLanding.feature.payouts': 'Payouts and income forecast',
  'guestLanding.feature.structure': 'A clear portfolio structure',
  'guestLanding.feature.achievements': 'Personal achievements',
  'guestLanding.feature.strategies': 'Create and manage strategies',
  'guestLanding.feature.news': 'News about your securities',
  'guestLanding.cardTitle': 'Your capital',
  'guestLanding.cardPeriod': 'all time',
  'guestLanding.card.portfolio': 'Portfolio',
  'guestLanding.card.payouts': 'Payouts',
  'guestLanding.card.analytics': 'Analytics',

  // Phone layout (docs/design/SPEC.md, stage M1)
  'nav.label': 'Sections',
  'nav.portfolio': 'Portfolio',
  'nav.markets': 'Markets',
  'nav.news': 'News',
  'nav.profile': 'Profile',
  'nav.profileAlert': 'API key not set',
  'selector.title': 'Portfolio',
  'selector.aria': 'Portfolio: {name}. Change',
  'live.on': 'Prices are live, {time}',
  'live.off': "Prices aren't updating",
  'live.title': 'Prices',
  'live.onText': 'Prices update every 5 seconds · {time}',
  'live.offText': "Prices aren't updating. Showing the last ones received. Check your connection.",
  'live.snapshot': 'Quantities and average prices as of {date}',
  'live.openProfile': 'Open profile',
  'refresh.now': 'Update from T-Invest',
  'refresh.running': 'Updating from T-Invest…',
  'refresh.noKey': "API key removed — broker data can't be updated.",
  'refresh.pull': 'Pull to refresh',
  'refresh.release': 'Release to refresh',
  'common.retry': 'Retry',
  'selector.manage': 'Manage accounts',
  'home.allTimeSuffix': 'all time',
  'home.todaySuffix': 'today',
  'home.periodSwitch': 'Tap to switch between today and all time',
  'accounts.title': 'Accounts',
  'accounts.showAll': 'All accounts · {count}',
  'structure.title': 'Allocation',
  'structure.types': 'Assets',
  'structure.sectors': 'Sectors',
  'structure.companies': 'Holdings',
  'structure.currencies': 'Currencies',
  'profile.title': 'Profile',
  'profile.data': 'Data',
  'profile.app': 'App',
  'profile.refresh': 'Update data',
  'profile.updatedAt': 'Broker data as of {date}',
  'profile.accounts': 'Accounts & portfolios',
  'profile.apiKey': 'T-Invest API key',
  'profile.keySet': 'saved',
  'profile.keyMissing': 'not set',
  'profile.needKey': 'T-Invest API key needed',
  'profile.birthDate': 'Date of birth',
  'empty.connectTitle': 'Connect T-Invest',
  'empty.loadTitle': 'Load your accounts',
  'goal.setMobile': 'Set a payout goal',
  'calendar.emptyMobile': 'No payouts in this period. Pull down to refresh.',
  'profile.import': 'Add accounts from T-Invest',

  'auth.loginTab': 'Login',
  'auth.registerTab': 'Register',
  'auth.name': 'Name',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.passwordConfirmation': 'Confirm password',
  'auth.signIn': 'Sign in',
  'auth.signingIn': 'Signing in…',
  'auth.createAccount': 'Create account',
  'auth.sendingEmail': 'Sending email…',
  'auth.resend': 'Resend verification email',
  'auth.sessionEnded': 'Your session has ended. Please sign in again.',
  'auth.registerInvalid': 'Fill all fields correctly and make sure both passwords match.',
  'auth.confirmResend': 'Verification email has already been sent and is still active. Send a new one anyway?',
  'auth.usePreviousLink': 'You can use the previously sent verification link.',
  'auth.registerFailed': 'Registration failed',
  'auth.loginInvalid': 'Enter a valid email and password.',
  'auth.loginSuccess': 'Login successful',
  'auth.loginFailed': 'Login failed',
  'auth.loggedOut': 'Logged out',
  'auth.logoutFailed': 'Logout failed',
  'auth.resendFailed': 'Failed to resend verification email',
  'auth.verified': 'Email verified successfully. You are now logged in.',
  'auth.verifyInvalid': 'Verification link is invalid or expired.',
  'auth.signInForSettings': 'Please sign in to open settings.',

  'settings.title': 'Settings',
  'settings.home': 'Home',
  'settings.profile': 'Profile',
  'settings.namePlaceholder': 'Name (optional)',
  'settings.saveProfile': 'Save profile',
  'settings.loadFailed': 'Failed to load settings',
  'settings.profileSaveFailed': 'Could not save profile',
  'settings.language': 'Language',
  'settings.languageHint': 'Language of the interface and emails. Saved in your profile.',
  'settings.languageSaveFailed': 'Could not save language',
  'settings.locale.ru': 'Русский',
  'settings.locale.en': 'English',
  'settings.apiKeys': 'API keys',
  'settings.apiKeysHint': 'One key per provider. Keys are encrypted on the server; we never show them again after saving.',
  'settings.source.TBANK': 'T-Bank (T-Invest)',
  'settings.keySaved': 'saved',
  'settings.keyPlaceholder': 'Paste API key',
  'settings.keyReplacePlaceholder': 'Enter new key to replace',
  'settings.saveKey': 'Save key',
  'settings.enterKey': 'Enter an API key before saving.',
  'settings.keySaveFailed': 'Could not save API key',
  'settings.confirmRemoveKey': 'Remove this API key?',
  'settings.keyRemoveFailed': 'Could not remove API key',

  'portfolios.load': 'Load from T-Invest',
  'portfolios.refreshAll': 'Refresh all',
  'portfolios.refreshing': 'Refreshing…',
  'portfolios.needKey': 'Save a read-only T-Invest API key to load your portfolios.',
  'portfolios.openSettings': 'Open settings',
  'portfolios.empty': 'No portfolios loaded yet.',
  'portfolios.keyRemoved': 'T-Bank API key is removed: showing the last loaded data, refresh is unavailable.',
  'portfolios.skipped': 'Skipped: {count} (the account is closed or not available for this key).',
  'portfolios.loadFailed': 'Failed to load portfolios',
  'portfolios.refreshFailed': 'Refresh failed',
  'portfolios.confirmRemove': 'Remove "{name}" from the app? Your T-Bank account is not affected.',
  'portfolios.removeFailed': 'Could not remove portfolio',
  'portfolios.live': 'Live prices · {time}',
  'portfolios.capital': 'Capital',
  'portfolios.select': 'Choose portfolio',
  'portfolios.accountsSection': 'Accounts',
  'portfolios.groupsSection': 'Composite',
  'portfolios.newGroup': '+ Composite portfolio',
  'portfolios.confirmRemoveGroup': 'Delete composite portfolio “{name}”? The accounts stay.',
  'portfolios.removeGroupFailed': 'Could not delete the composite portfolio',

  'portfolio.updated': 'updated {date}',
  'portfolio.livePrice': 'Live price, {time}',
  'portfolio.pcs': '{n} pcs',
  'portfolio.avgToCurrent': 'Average purchase price → current price',
  'portfolio.fifo': 'FIFO: {price}',
  'portfolio.blocked': 'blocked',
  'portfolio.shareHint': 'Share of the portfolio value',
  'portfolio.sort': 'Sort',
  'portfolio.sort.value': 'Value',
  'portfolio.sort.name': 'Name',
  'portfolio.sort.yieldAbs': 'Gain ₽',
  'portfolio.sort.yieldPercent': 'Gain %',
  'portfolio.sort.reverse': 'Reverse order',
  'portfolio.sort.bySector': 'By sector',
  'portfolio.sort.nameGlyph': 'A–Z',
  'portfolio.noPositions': 'No positions.',
  'portfolio.gainPeriod': 'Gain {period}',
  'portfolio.refresh': 'Refresh',
  'portfolio.remove': 'Remove from app',
  'calendar.title': 'Payout calendar',
  'calendar.period': 'Calendar period',
  'calendar.next12': 'Next 12 months',
  'calendar.total': 'Total',
  'calendar.perMonth': 'Per month',
  'calendar.perMonthInline': '≈ {amount} a month',
  'calendar.dividends': 'Dividends',
  'calendar.coupons': 'Coupons',
  'calendar.tax': 'Tax',
  'calendar.taxHint': 'Tax withheld from received dividends and coupons. Payouts are shown before tax.',
  'calendar.maturities': 'Maturities',
  'calendar.maturityHint': 'Bond face value repaid, not counted in the total',
  'calendar.passiveHint': 'Dividends and coupons for the next 12 months after 13% tax, to the current portfolio value — as in Analytics',
  'calendar.empty': 'No payouts in this period. If data was never loaded, select “Refresh all” in the profile menu.',
  'calendar.chartLabel': 'Payouts by period',
  'calendar.bucketEmpty': 'No payouts.',
  'calendar.series.paid': 'Paid',
  'calendar.series.declared': 'Declared',
  'calendar.series.forecast': 'Forecast',
  'calendar.series.maturity': 'Maturities',
  'calendar.noInstrument': 'Not linked to an asset',
  'calendar.taxOnly': 'tax {tax}',
  'calendar.withTax': '{gross} − tax {tax}',
  'calendar.kind.dividend': 'Dividend',
  'calendar.kind.coupon': 'Coupon',
  'calendar.kind.maturity': 'Maturity',
  'calendar.kind.dividend_tax': 'Dividend tax',
  'calendar.kind.coupon_tax': 'Coupon tax',
  'calendar.status.paid': 'paid',
  'calendar.status.paidHint': 'The money has reached the account',
  'calendar.status.declared': 'declared',
  'calendar.status.declaredHint': 'The payout is declared, waiting for the money',
  'calendar.status.recommended': 'declared',
  'calendar.status.recommendedHint': 'Board recommendation, shareholders’ meeting is ahead',
  'calendar.status.awaiting': 'expected',
  'calendar.status.awaitingHint': 'Record date passed, waiting for the money',
  'calendar.status.forecast': 'forecast',
  'calendar.status.forecastHint': 'Estimate: analysts’ forecast, last year’s payout repeated or the last known coupon',
  'calendar.status.unknown': 'amount unknown',
  'calendar.status.unknownHint': 'The payout amount is not set yet',
  'calendar.amountUnknown': 'not set',
  'calendar.loadFailed': 'Could not load the payout calendar',
  'sections.label': 'Sections',
  'sections.portfolio': 'Portfolio',
  'sections.markets': 'Markets',
  'sections.strategy': 'Strategy management',
  'sections.news': 'News',
  'sections.portfolioShort': 'Portfolio',
  'sections.cashflowShort': 'Payouts',
  'sections.analyticsShort': 'Analytics',
  'portfolios.keyRemovedShort': 'API key removed ·',
  'summary.value': 'Value',
  'summary.valueHint': 'Current portfolio value. Prices update in real time while the exchange is open; foreign-currency securities are converted at today\'s CBR rate. Invested is the value of the current securities at the average purchase price.',
  'summary.assetsValue': 'Assets',
  'summary.cashValue': 'Currency and cash',
  'summary.invested': '{amount} invested',
  'summary.profit': 'Profit',
  'summary.profitHint': 'Top: profit from the price change of the current securities against the average purchase price (as the broker reports it), without dividends, coupons and sold securities. Bottom: change over the last trading day.',
  'summary.perDay': 'Today',
  'summary.passive': 'Passive income',
  'summary.passiveHint': 'Dividends and coupons for the next 12 months, as "Total" in the payout calendar: declared, recommended and forecast. Redemptions are not counted. Amounts after 13% tax. Large figure: yield on the current value; green: yield on the invested amount.',
  'summary.onInvested': '{percent} on invested',
  'summary.perYear': '{amount} a year',
  'analytics.empty': 'No positions with a known value',
  'analytics.skipped': 'Positions without a price or exchange rate left out: {count}',
  'analytics.types': 'Asset types',
  'analytics.sectors': 'Sectors',
  'analytics.allSectors': 'All sectors',
  'analytics.companies': 'Companies',
  'analytics.companiesCount': 'securities: {count}',
  'analytics.top5': 'Top 5 — {percent}',
  'analytics.top10': 'Top 10 — {percent}',
  'analytics.othersRing': 'Other securities: {count}',
  'analytics.showAll': 'Show all {count}',
  'analytics.showMore': 'Show {count} more',
  'analytics.showLess': 'Show less',
  'analytics.expandAll': 'Expand all',
  'analytics.itemsCount': 'Securities: {count}',
  'analytics.collapseAll': 'Collapse all',
  'analytics.currencies': 'Currencies',
  'analytics.total': 'Total',
  'analytics.securities': 'Securities',
  'analytics.cash': 'Currency and cash',
  'performance.title': 'Portfolio growth',
  'performance.mode.return': 'Return',
  'performance.mode.value': 'Value',
  'performance.period.1m': '1M',
  'performance.period.3m': '3M',
  'performance.period.6m': '6M',
  'performance.period.1y': '1Y',
  'performance.period.ytd': 'YTD',
  'performance.period.all': 'All time',
  'performance.index': 'Index',
  'performance.indexName.MCFTRR': 'Stocks, net (MCFTRR)',
  'performance.indexName.MCFTR': 'Stocks, gross (MCFTR)',
  'performance.indexName.RGBITR': 'Government bonds (RGBITR)',
  'performance.legend.portfolio': 'Portfolio',
  'performance.legend.value': 'Value',
  'performance.legend.invested': 'Invested',
  'performance.income': 'Income for the period',
  'performance.netFlow': 'Deposits − withdrawals',
  'performance.ahead': 'Your portfolio is ahead of {index} by {money} and {percent}',
  'performance.behind': 'Your portfolio is behind {index} by {money} and {percent}',
  'performance.aheadPercentBehindMoney': 'Your portfolio is ahead of {index} by {percent}, but behind by {money} in roubles',
  'performance.behindPercentAheadMoney': 'Your portfolio is behind {index} by {percent}, but ahead by {money} in roubles',
  'performance.pending': 'Rebuilding the history from operations — usually under a minute.',
  'performance.updating': 'Updating the history…',
  'performance.error': 'Could not rebuild the history. Try refreshing the portfolio.',
  'performance.empty': 'No history yet.',
  'performance.loadFailed': 'Could not load the history.',
  'performance.since': 'History starts {date}',
  'performance.wholeAccounts': 'History covers the whole accounts, not the chosen securities',
  'performance.mismatches': 'Differences with the broker: {count} — the chart may be inexact',
  'performance.hint.twr': 'Time-weighted return (TWR): deposits and withdrawals do not affect it, so it compares with an index. Index roubles are what it would have earned on the same money: the same value at the start, the same deposits and withdrawals on the same days. The history is rebuilt from operations and daily prices; since loading, broker totals are used.',
  'performance.hint.indexes': 'MCFTRR and MCFTR are MOEX total return indexes (dividends reinvested): net after resident tax, gross before tax. RGBITR is government bonds with coupons.',
  'performance.withInflation': '+ inflation',
  'performance.legend.inflation': 'Inflation',
  'performance.legend.investedReal': 'Invested + inflation',
  'performance.inflation.ahead': 'Your portfolio is ahead of inflation by {money} and {percent}',
  'performance.inflation.behind': 'Your portfolio is behind inflation by {money} and {percent}',
  'performance.inflation.aheadPercentBehindMoney': 'Your portfolio is ahead of inflation by {percent}, but behind by {money} in roubles',
  'performance.inflation.behindPercentAheadMoney': 'Your portfolio is behind inflation by {percent}, but ahead by {money} in roubles',
  'performance.inflationUntil': 'Inflation through {date}: Rosstat publishes it with a lag, so it is compared on that date',
  'performance.hint.inflation': 'Inflation is the Rosstat consumer price index: monthly, the latest weeks by the weekly estimate. Inflation roubles are what you needed to earn just to keep purchasing power. "Invested + inflation" is every deposit and withdrawal grown with prices from its own day.',
  'performance.aria.value': 'Value {value}, income for the period {income}',
  'performance.aria.return': 'Portfolio return {portfolio}, index {index} {indexValue}',
  'sector.energy': 'Oil and gas',
  'sector.utilities': 'Utilities',
  'sector.materials': 'Materials',
  'sector.financial': 'Financials',
  'sector.real_estate': 'Real estate',
  'sector.consumer': 'Consumer',
  'sector.it': 'IT',
  'sector.telecom': 'Telecom',
  'sector.industrials': 'Industrials',
  'sector.health_care': 'Health care',
  'sector.other': 'Other',
  'sector.government': 'Government and municipal bonds',
  'sector.funds': 'Funds',
  'sector.cash': 'Currency and cash',
  'sector.unlabelled': 'No industry',
  'goal.title': 'Payout goal',
  'goal.set': 'Payout goal',
  'goal.hint': 'in rubles; compared with payouts for the next 12 months',
  'goal.period': 'Goal period',
  'goal.per.month': 'Per month',
  'goal.per.year': 'Per year',
  'goal.amount': 'Amount',
  'goal.label.month': 'Goal: {amount}/mo',
  'goal.label.year': 'Goal: {amount}/yr',
  'goal.progress.month': '≈ {value} a month of {target}',
  'goal.progress.year': '{value} over 12 months of {target}',
  'goal.save': 'Save',
  'goal.remove': 'Delete goal',
  'goal.invalidAmount': 'Enter an amount above zero.',
  'goal.saveFailed': 'Could not save the goal',
  'portfolio.composite': 'Composite portfolio',
  'portfolio.capitalHint': 'All accounts',
  'portfolio.accountCount': 'accounts: {count}',
  'portfolio.edit': 'Edit',
  'portfolio.removeGroup': 'Delete portfolio',
  'portfolio.outsideTotal': 'not in total',
  'portfolio.outsideTotalHint': 'No CBR rate for this currency: not counted in the total',
  'group.titleNew': 'New composite portfolio',
  'group.titleEdit': 'Composite portfolio',
  'group.name': 'Name',
  'group.accounts': 'Accounts and assets',
  'group.allAssets': 'All assets ({count})',
  'group.someAssets': 'Assets: {selected} of {count}',
  'group.allAssetsToggle': 'All assets',
  'group.allAssetsHint': 'While all are checked, new assets of the account join automatically.',
  'group.needName': 'Enter a name.',
  'group.needAccount': 'Check at least one account.',
  'group.needAsset': 'Check at least one asset in “{name}”.',
  'group.save': 'Save',
  'group.saveFailed': 'Could not save the composite portfolio',

  'import.title': 'Load portfolios from T-Invest',
  'import.hint': 'Choose accounts to load. Already loaded ones will be refreshed.',
  'import.loadingAccounts': 'Loading accounts…',
  'import.allAccounts': 'All accounts',
  'import.loaded': 'loaded',
  'import.noAccounts': 'No open accounts found for this key.',
  'import.submit': 'Load ({count})',
  'import.accountsFailed': 'Could not load accounts from T-Invest',
  'import.failed': 'Import failed',

  'accountType.ACCOUNT_TYPE_TINKOFF': 'Brokerage',
  'accountType.ACCOUNT_TYPE_TINKOFF_IIS': 'IIS',
  'accountType.ACCOUNT_TYPE_INVEST_BOX': 'Invest box',
  'accountType.ACCOUNT_TYPE_INVEST_FUND': 'Fund',
  'accountType.ACCOUNT_TYPE_DEBIT': 'Debit',
  'accountType.ACCOUNT_TYPE_SAVING': 'Savings',
  'accountType.other': 'Account',

  'instrumentType.share': 'Shares',
  'instrumentType.bond': 'Bonds',
  'instrumentType.etf': 'Funds',
  'instrumentType.currency': 'Currencies',
  'instrumentType.futures': 'Futures',
  'instrumentType.option': 'Options',
  'instrumentType.sp': 'Structured notes',
  'instrumentType.other': 'Other',

  'lock.enterPin': 'Enter PIN',
  'lock.locked': 'App locked',
  'lock.entered': '{n} of {total} entered',
  'lock.keypad': 'PIN keypad',
  'lock.deleteDigit': 'Delete digit',
  'lock.signInWith': 'Sign in with {method}',
  'lock.checking': 'Checking…',
  'lock.wrongPin': 'Wrong PIN. Attempts left: {n}',
  'lock.wrongPinLast': 'Wrong PIN. 1 attempt left before sign-out',
  'lock.tooManyAttempts': 'Too many wrong attempts. Sign in with your password.',
  'lock.network': "Can't reach the server. Check your connection.",
  'lock.retry': 'Retry',
  'lock.failed': "Couldn't unlock. Try again.",
  'lock.passkeyFailedPin': "Couldn't verify {method}. Enter your PIN.",
  'lock.passkeyFailedRetry': "Couldn't verify {method}. Try again.",

  'security.title': 'Security',
  'security.hint': 'The app locks when opened and after 5 minutes in the background.',
  'security.unsupported': "This browser doesn't support passwordless sign-in.",
  'security.passkeyOn': '{methodCap} is on for this device',
  'security.passkeyAddFailed': "Couldn't add the device",
  'security.pin': 'PIN code',
  'security.changePin': 'Change PIN',
  'security.confirmPassword': 'Confirm with your password',
  'security.continue': 'Continue',
  'security.wrongPassword': 'Wrong password',
  'security.choosePin': 'Choose a 4-digit PIN',
  'security.repeatPin': 'Repeat your PIN',
  'security.pinMismatch': "PINs don't match. Try again.",
  'security.pinSaved': 'PIN saved',
  'security.failed': 'Something went wrong',

  'onboarding.pinHint': "You'll enter it when you open the app.",
  'onboarding.faceIdTitle': 'Use {method}?',
  'onboarding.faceIdHint': 'Open the app with {method} instead of your PIN.',
  'onboarding.faceIdUse': 'Use {method}',
  'onboarding.faceIdSkip': 'Not now',
  'security.faceIdOnDevice': '{methodCap} on this device',
  'security.faceIdHint': 'Open the app with {method} instead of the PIN.',
  'security.passkeyOff': '{methodCap} is off for this device',
  'security.pinHint': 'A new PIN is set after every sign-in with the password.',

  'notifications.title': 'Notifications',
  'notifications.hint': 'About payouts, declared dividends and record dates for securities in your portfolio.',
  'notifications.device': 'Notifications on this device',
  'notifications.event.payout_received': 'Payout received',
  'notifications.event.dividend_declared': 'Dividend declared',
  'notifications.event.record_date': 'Record date in 3 days',
  'notifications.event.achievement': 'New achievement',
  'notifications.test': 'Send a test notification',
  'notifications.on': 'Notifications are on for this device',
  'notifications.off': 'Notifications are off for this device',
  'notifications.failed': 'Could not change notifications',
  'notifications.denied': 'Notifications are blocked in phone or browser settings',
  'notifications.homeScreen': 'Add the app to the Home Screen: in Safari, Share → Add to Home Screen',
  'notifications.unsupported': 'This browser does not support notifications',
  'notifications.notConfigured': 'Notifications are not set up on the server',

  'common.soon': 'Coming soon',
  'common.inDevelopment': 'In development',
  'home.operations': 'Operations',
  'home.payouts': 'Payouts',
  'home.analytics': 'Analytics',
  'home.achievements': 'Achievements',
  'achievements.best': 'best',
  'achievements.aheadLeft': 'ahead · {left} to go',
  'achievements.streakIsBest': 'Your best streak',
  'achievements.stepGroup.other': '{from} → {to} · {count} steps at once',
  'achievements.stepGroup.one': '{from} → {to} · {count} step in a day',
  'achievements.firstVsLast.other': 'First {step} took {first}, the last {count} steps — {days} each on average',
  'achievements.firstVsLast.one': 'First {step} took {first}, the last step — {days}',
  'achievements.averageOne': 'First step — {days}',
  'achievements.from': 'from {level}',
  'achievements.freshTitle': 'New milestone — {level}',
  'achievements.loadFailed': 'Couldn\'t load achievements',
  'achievements.empty': 'Achievements appear once the value history is built — usually overnight',
  'achievements.nextTitle': 'Next milestone',
  'achievements.left': 'Left {sum}',
  'achievements.forecastDay': '~{date} at current pace',
  'achievements.forecastMonth': '~{date} at current pace',
  'achievements.forecastYear': '~{year} at current pace',
  'achievements.forecast.short': 'A forecast appears after 3 months of history',
  'achievements.forecast.flat': 'No forecast: the portfolio has not grown in half a year. Every top-up brings the milestone closer',
  'achievements.forecast.far': 'More than 5 years at the current pace',
  'achievements.forecastHintLabel': 'How the forecast works',
  'achievements.forecastHint': 'The average pace over the last 6 months: top-ups and price growth. If the pace changes, so does the date.',
  'achievements.belowLevel': 'The {level} milestone stays yours: now {sum} below it',
  'achievements.now': 'Now',
  'achievements.invested': 'Invested',
  'achievements.market': 'Market',
  'achievements.freshWhen': '{date}, in {days}',
  'achievements.allLevels': 'All milestones · {count}',
  'achievements.levelsTitle': 'Milestones',
  'achievements.ladder.capital': 'Portfolio',
  'achievements.ladder.shares': 'Shares',
  'achievements.onTheWayShort': '{days} on the way',
  'achievements.until': '{sum} to {level}',
  'achievements.in': 'in {days}',
  'achievements.fastest': 'fastest',
  'achievements.firstLevel': 'First milestone — {level}',
  'achievements.firstSteps': 'First steps · {from} → {to} · {count}',
  'achievements.atStartRow': 'At start: {from} – {to} · {count}',
  'achievements.comebackTitle': 'You\'re back since {month} after a {months}-month break',
  'achievements.comebackText': 'Count your journey from the comeback? The past stays in the timeline.',
  'achievements.comebackAccept': 'Count from {month}',
  'achievements.comebackDismiss': 'No thanks',
  'achievements.stepsTitle': 'Every {step}',
  'achievements.step': 'Step',
  'achievements.average': 'Last 5 steps — {days} on average',
  'achievements.averageAll.one': 'All {count} step — {days} on average',
  'achievements.averageAll.other': 'All {count} steps — {days} on average',
  'achievements.firstStep': 'The first {step} step is on its way — bars appear once the portfolio passes it',
  'achievements.daysAxis': 'days',
  'achievements.stepDone': '{range} · {days} · {from} — {to}',
  'achievements.stepGoing': '{range} · {days} on the way · {sum} left',
  'achievements.atStartRange': 'Grey strip — steps passed before the start (up to {level})',
  'achievements.put': 'Put in {sum}',
  'achievements.marketGave': 'market {sum}',
  'achievements.marketLegend': 'the market gave more than half of the step',
  'achievements.pathTitle': 'Journey',
  'achievements.pathEmpty': 'The first moment appears with your first trade',
  'achievements.pathAll': 'Whole journey · {count}',
  'achievements.path.capital': 'Portfolio reached {level}',
  'achievements.path.firstMillion': 'First million',
  'achievements.path.capitalFrom': '{date} · {days} from {level}',
  'achievements.path.capitalStart': '{date} · {days} from the start',
  'achievements.path.firstTrade': 'First trade — {ticker}',
  'achievements.path.firstDividend': 'First dividend — {ticker}',
  'achievements.path.firstCoupon': 'First coupon — {ticker}',
  'achievements.path.years.one': '{count} year on the market',
  'achievements.path.years.other': '{count} years on the market',
  'achievements.path.comeback': 'Comeback after a {months}-month break',
  'achievements.path.streak': '{months} months of top-ups in a row',
  'achievements.path.income': 'Passive income — about {level} a month',
  'achievements.path.drawdown': 'Lived through a −{depth}% drawdown without taking money out',
  'achievements.path.max10': 'No security above 10% of the portfolio',
  'achievements.path.sectors': 'Capital in {count} sectors',
  'achievements.firstRun': 'First run · {from} — {to}',
  'achievements.beforeStart': 'Before the start · {from} — {to}',
  'achievements.beforeBest': 'best — {level} · moments: {count}',
  'achievements.habitsTitle': 'Your habits',
  'achievements.habit.streak': 'Monthly top-ups',
  'achievements.habit.income': 'Passive income',
  'achievements.habit.drawdown': 'Resilience',
  'achievements.habit.diversity': 'Diversification',
  'achievements.monthsShort': '{count} mo.',
  'achievements.perMonth': '≈ {sum}/mo.',
  'achievements.streakWaiting': 'No top-up this month yet — the streak holds until the end of the month',
  'achievements.streakBestNext': 'Your best streak · {left} mo. to {level} mo.',
  'achievements.streakBest': 'Best streak — {best} mo.',
  'achievements.streakRule': 'A month counts if you topped up at least ₽500',
  'achievements.incomeYear': 'over 12 months, after tax',
  'achievements.incomeMonths.one': 'over {count} month, after tax',
  'achievements.incomeMonths.other': 'over {count} months, after tax',
  'achievements.incomeTotals': '12 months — {year}, since the start — {total}',
  'achievements.drawdownLived': 'Lived through a drawdown without taking money out',
  'achievements.drawdownNone': 'No drawdowns of 10% or more yet',
  'achievements.drawdownNow': 'Drawdown now −{depth}% · you put in {sum} meanwhile',
  'achievements.drawdownNowShort': 'Now −{depth}%',
  'achievements.drawdownDates': '{from} to {to}',
  'achievements.sectorsCount.one': '{count} sector',
  'achievements.sectorsCount.other': '{count} sectors',
  'achievements.largestShare': 'Largest security — {ticker}, {share}%',
  'achievements.max10Since': 'No security above 10% — since {date}',
  'achievements.max10Not': '«No security above 10%» is still ahead',
  'achievements.rule.streak': 'A month counts if you topped up at least ₽500 in it; withdrawals do not matter. The current month does not break the streak until it ends.',
  'achievements.rule.income': 'Dividends and coupons after tax over the last 12 months, divided by 12.',
  'achievements.rule.drawdown': 'The portfolio fell 10% or more from its high (top-ups aside), came back to it — and you did not take money out.',
  'achievements.rule.diversity': 'Sectors of at least 2% of the portfolio. «Not above 10%» — 30 days in a row no security is worth more than 10% of the portfolio; funds and money do not count.',
  'achievements.levels': 'Levels',
  'achievements.ahead': 'ahead',
  'achievements.counting': 'Calculating…',
  'achievements.startRow': 'Counting from {date}',
  'achievements.startRowReturn': 'Counting from the comeback — {date}',
  'achievements.startRowCustom': 'Counting from {date} · custom',
  'achievements.startTitle': 'Start point',
  'achievements.startHint': 'Which day to count the journey from. Levels reached by then are marked «at start», the past stays in the timeline.',
  'achievements.startFirst': 'From the first operation — {date}',
  'achievements.startReturn': 'From the comeback — {date}',
  'achievements.startReturnNote': 'after a {months}-month break, {month}',
  'achievements.startCustom': 'Custom date',
  'achievements.save': 'Save',
  'achievements.saveFailed': 'Could not save',
  'achievements.days.one': '{count} day',
  'achievements.days.other': '{count} days',
  // IIS deduction limit (docs/iis/SPEC.md)
  'iis.title': 'IIS deposits in {year}',
  'iis.left': '{sum} left to deposit',
  'iis.done': 'The {year} limit is reached',
  'iis.forDeduction': 'for the largest deduction',
  'iis.notLoaded': 'Deposits are not loaded yet',
  'settings.iisLimit': 'IIS deposits left',
  'settings.iisLimitHint': 'How much to deposit to IIS this year for the largest deduction (400,000 ₽)',
  'settings.preferencesSaveFailed': 'Could not save the setting',
  // News (docs/news/SPEC.md)
  'news.title': 'News',
  'news.source': 'MarketTwits on Telegram',
  'news.onlyMine': 'Only my securities',
  'news.emptyMine': 'No news about your securities yet',
  'news.noTickers': 'Your portfolios have no securities to look news up for',
  'news.empty': 'No news yet',
  'news.showAll': 'Show all news',
  'news.edited': 'edited',
  'news.mediaOnly': 'Photo or video',
  'news.more': 'Show more',
  'news.less': 'Show less',
  'news.loadMore': 'Show more',
  'news.end': 'That is all the news',
  'news.loadFailed': 'Could not load the news',
  'news.loadMoreFailed': 'Could not load',
  'news.filter': 'Filter',
  'news.filterTitle': 'Filter by tags',
  'news.searchTags': 'Search tags',
  'news.noTagsFound': 'No tags found',
  'news.showAllTags': 'All ({count})',
  'news.category.ticker': 'Tickers',
  'news.category.country': 'Country',
  'news.category.commodity': 'Commodities',
  'news.category.industry': 'Industry',
  'news.category.monetary': 'Monetary policy',
  'news.category.corporate': 'Corporate actions',
  'news.category.politics': 'Politics and people',
  'news.category.organization': 'Organizations',
  'news.category.other': 'Other',
  'news.tickerKind.share_ru': 'Russian shares',
  'news.tickerKind.share_foreign': 'foreign shares',
  'news.tickerKind.crypto': 'crypto',
  'news.tickerKind.index': 'indexes',
  'news.tickerKind.currency': 'currencies',
  'news.tickerKind.commodity_quote': 'commodity quotes',
  'news.tickerKind.other': 'other',
  'news.modeLabel': 'How to combine tags',
  'news.mode.or': 'OR',
  'news.mode.and': 'AND',
  'news.removeTag': 'Remove {tag} from the filter',
  'news.clearFilter': 'Clear',
  'news.emptyFilter': 'No news for this filter',
  'news.addToFilter': 'Add to the filter',
  'operations.title': 'Operations',
  'operations.backHome': 'Portfolio',
  'operations.back': 'Back',
  'operations.syncedAt': 'Data as of {date}',
  'operations.notSynced': '{count} accounts not loaded yet',
  'operations.filter': 'Categories',
  'operations.all': 'All',
  'operations.reset': 'Reset',
  'operations.resetFilter': 'Clear filter',
  'operations.count.one': '{count} operation',
  'operations.count.other': '{count} operations',
  'operations.cat.trades': 'Trades',
  'operations.cat.fees': 'Fees',
  'operations.cat.taxes': 'Taxes',
  'operations.cat.varmargin': 'Variation margin',
  'operations.cat.repayments': 'Redemptions',
  'operations.cat.income': 'Dividends & coupons',
  'operations.cat.deposits': 'Deposits',
  'operations.cat.withdrawals': 'Withdrawals',
  'operations.cat.transfers': 'Transfers',
  'operations.cat.other': 'Other',
  'operations.period': 'Period',
  'operations.periodAll': 'All time',
  'operations.customPeriod': 'Custom dates',
  'operations.from': 'From',
  'operations.to': 'To',
  'operations.apply': 'Show',
  'operations.forYear': 'in {year}',
  'operations.forPeriod': 'for the period',
  'operations.forAllTime': 'all time',
  'operations.qty': '{qty} pcs',
  'operations.qtyPrice': '{qty} @ {price}',
  'operations.accrued': 'Accrued interest {amount}',
  'operations.unknownType': 'Operation',
  'operations.emptyNotLoaded': "Operations aren't loaded yet",
  'operations.emptyNotLoadedText': "They'll load overnight or when you update data.",
  'operations.loadNow': 'Load now',
  'operations.empty': 'No operations yet',
  'operations.emptyFilter': 'No operations match the filter',
  'operations.noAccounts': 'This portfolio has no accounts',
  'operations.loadMore': 'Show more',
  'operations.loadFailed': "Couldn't load operations",
  'operations.loadMoreFailed': "Couldn't load",
  'operations.end': "That's all · first on {date}",
  'opType.1': 'Deposit',
  'opType.2': 'Coupon tax',
  'opType.3': 'Securities out',
  'opType.4': 'Overnight income',
  'opType.5': 'Tax',
  'opType.6': 'Redemption',
  'opType.7': 'Sale to card',
  'opType.8': 'Dividend tax',
  'opType.9': 'Withdrawal',
  'opType.10': 'Amortization',
  'opType.11': 'Tax correction',
  'opType.12': 'Account service fee',
  'opType.13': 'Benefit tax',
  'opType.14': 'Margin fee',
  'opType.15': 'Buy',
  'opType.16': 'Buy from card',
  'opType.17': 'Securities in',
  'opType.18': 'Sell (margin call)',
  'opType.19': 'Broker fee',
  'opType.20': 'Buy (margin call)',
  'opType.21': 'Dividends',
  'opType.22': 'Sell',
  'opType.23': 'Coupon',
  'opType.24': 'Success fee',
  'opType.25': 'Dividend transfer',
  'opType.26': 'Variation margin in',
  'opType.27': 'Variation margin out',
  'opType.28': 'Buy on expiration',
  'opType.29': 'Sell on expiration',
  'opType.30': 'Autofollow: management fee',
  'opType.31': 'Autofollow: success fee',
  'opType.32': 'Tax 15%',
  'opType.33': 'Coupon tax 15%',
  'opType.34': 'Dividend tax 15%',
  'opType.35': 'Benefit tax 15%',
  'opType.36': 'Tax correction 15%',
  'opType.37': 'Repo tax 15%',
  'opType.38': 'Repo tax',
  'opType.39': 'Repo tax',
  'opType.40': 'Repo tax refund',
  'opType.41': 'Repo tax 15%',
  'opType.42': 'Repo tax refund 15%',
  'opType.43': 'Dividends to card',
  'opType.44': 'Tax correction',
  'opType.45': 'Cash balance fee',
  'opType.46': 'Currency withdrawal fee',
  'opType.47': 'Stamp duty',
  'opType.50': 'SWIFT withdrawal',
  'opType.51': 'SWIFT deposit',
  'opType.53': 'Transfer to card',
  'opType.54': 'Transfer from card',
  'opType.55': 'Withdrawal fee',
  'opType.56': 'Advice service',
  'opType.57': 'Securities from IIS',
  'opType.58': 'Securities between accounts',
  'opType.59': 'Transfer to another account',
  'opType.60': 'Transfer from another account',
  'opType.61': 'Overnight placement',
  'opType.62': 'Fee',
  'opType.63': 'Overnight income',
  'opType.64': 'Option exercise',
  'opType.65': 'Futures exercise',
  // Quotes above the heatmap (docs/quotes/SPEC.md)
  'quotes.title': 'Quotes',
  'quotes.name.imoex2': 'IMOEX2',
  'quotes.name.rgbi': 'RGBI',
  'quotes.name.usd': 'US dollar',
  'quotes.name.cny': 'Yuan',
  'quotes.name.brent': 'Brent oil',
  'quotes.name.gas': 'Natural gas',
  'quotes.name.gold': 'Gold',
  // Market overview on «Рынки» (docs/market-overview/SPEC.md)
  'market.today.title': 'Market today',
  'market.today.rvi': 'RVI fear index',
  'market.today.rviHint': 'Moscow Exchange volatility index: how much investors expect the stock market to swing over the next month. Up means more anxiety, down means calmer.',
  'market.today.rviMore': 'RVI is computed from prices of options on the RTS index for the next 30 days, like VIX in the US. When investors fear sharp moves, they pay more for protection and RVI rises. It usually jumps when the market falls, hence the name «fear index».',
  'market.today.level.calm': 'Calm',
  'market.today.level.normal': 'Normal',
  'market.today.level.anxious': 'Anxious',
  'market.today.level.panic': 'Panic',
  'market.today.levelAria': 'RVI level scale',
  'market.today.range.calm': 'below 25',
  'market.today.range.normal': '25–35',
  'market.today.range.anxious': '35–50',
  'market.today.range.panic': '50 and above',
  'market.today.rviScale': 'Bounds from RVI history since 2015: on half of the days it was 23.5–36.8 (median 29.7), above 50 only in crises (up to 124 in 2020, 143 in 2022).',
  'market.today.breadth': 'Index shares',
  'market.today.up': 'Up {count}',
  'market.today.down': 'Down {count}',
  'market.today.flat': 'Unchanged {count}',
  'market.leaders.title': 'Top movers',
  'market.leaders.modeAria': 'Top gainers or losers',
  'market.leaders.up': 'Gainers',
  'market.leaders.down': 'Losers',
  'market.leaders.noneUp': 'No index share is up today',
  'market.leaders.noneDown': 'No index share is down today',
  'market.sectors.title': 'Sectors today',
  'market.sectors.hint': 'Change with index weights',
  'market.noData': 'No data',
  // Instrument screen (docs/instrument/SPEC.md)
  'instrument.notFound': 'Instrument not found',
  'instrument.loadFailed': 'Could not load the instrument',
  'instrument.today': 'today',
  'instrument.yours': 'You hold · {name}',
  'instrument.value': 'Value',
  'instrument.quantity': 'Quantity',
  'instrument.average': 'Average → current',
  'instrument.profit': 'Return',
  'instrument.tab.chart': 'Chart',
  'instrument.tab.news': 'News',
  'instrument.tab.dividends': 'Dividends',
  'instrument.tab.operations': 'Operations',
  'instrument.tab.calc': 'Payout',
  'tpay.failed': 'Could not load the calculation',
  'tpay.title': 'Estimated payout per unit',
  'tpay.retry': 'Retry',
  'tpay.accruedTitle': 'Accumulated per unit as of today',
  'tpay.asOf': 'as of {date}',
  'tpay.noUnits': 'The unit count is not yet available for calculation',
  'tpay.feeProgress': 'Towards fees: {covered} of {total}',
  'tpay.feesFirst': 'The first receipts cover the fees',
  'tpay.feesAccounted': 'Fees accounted for',
  'tpay.monthForecast': 'Monthly forecast — {value} per unit',
  'tpay.withUnconfirmed': 'Including T+1 — {value} per unit',
  'tpay.unconfirmedCoupons': 'Fund coupons without news',
  'tpay.withUnconfirmedPerUnit': 'Including T+1 per unit',
  'tpay.unconfirmedNote': 'Includes confirmed coupons and coupons without news whose estimated credit date has arrived. This is usually T+1 business day; the delay is refined using the bond’s history. The monthly fee is deducted once from the combined amount, then the remainder is divided by units. Unknown coupon amounts are estimated from the previous payment.',
  'tpay.todayFormula': 'Accumulated as of today',
  'tpay.receivedCoupons': 'Confirmed coupons',
  'tpay.feesCovered': 'Towards fees',
  'tpay.income': 'Fund income for distribution',
  'tpay.confirmedNote': 'Receipts are confirmed by fund news. Amounts and fees are estimates. This is income in the fund, not a credit to your account.',
  'tpay.forecastFormula': 'Monthly forecast',
  'tpay.net': 'After {rate}% tax — {value}',
  'tpay.period': 'Period {start}–{end} · record date {record} · paid by {pay}',
  'tpay.updated': 'Last calculated: {time}',
  'tpay.formula': 'How it is calculated',
  'tpay.couponsSum': 'Coupons',
  'tpay.expectedPart': 'of which expected {value}',
  'tpay.feesLabel': 'fees',
  'tpay.unitsLabel': 'units',
  'tpay.fees': 'Fees',
  'tpay.feesStatement': 'payable in the NAV statement of {date} + estimated other expenses at {rate} % of NAV a year / 12',
  'tpay.feesEstimate': 'estimate {rate} % of NAV a year / 12',
  'tpay.units': 'Units',
  'tpay.unitsStatement': 'from the statement of {date}',
  'tpay.unitsSnapshot': 'NAV {nav} ÷ unit price {price}',
  'tpay.perUnit': 'Per unit',
  'tpay.rules': 'Fund rules',
  'tpay.statement': 'NAV statement of {date}',
  'tpay.coupons': 'Coupons of the month · {count}',
  'tpay.noCoupons': 'No coupons yet',
  'tpay.couponDates': 'coupon {coupon} · record {fix} · credited {credit}',
  'tpay.qtyStatement': 'quantity from the statement of {date}',
  'tpay.qtyTrades': 'quantity: statement of {date} + fund deals',
  'tpay.qtySnapshot': 'quantity from the composition {time}',
  'tpay.estimated': '(previous coupon)',
  'tpay.status.credited': 'credited',
  'tpay.status.unconfirmed': 'awaiting confirmation',
  'tpay.status.amount_pending': 'amount pending',
  'tpay.status.expected': 'expected',
  'tpay.status.after_period': 'after the period',
  'tpay.status.skipped': 'not counted',
  'tpay.accuracy': 'Accuracy in past months',
  'tpay.accuracyNote': 'The same calculation against the payout in the NAV statement. Until hourly snapshots exist, quantities come from the previous month’s statement.',
  'tpay.month': 'Month',
  'tpay.forecastCol': 'Calculated',
  'tpay.factCol': 'Fact',
  'tpay.diffCol': 'Difference',
  'instrument.operationsFailed': 'Could not load the operations',
  'instrument.noOperations': 'No operations with this instrument',
  'instrument.dividendsFailed': 'Could not load the dividends',
  'instrument.noDividends': 'No dividends yet',
  'instrument.payment': 'paid {date}',
  'instrument.dividendMark': 'Dividend {amount} · record date {date}',
  'instrument.dividendStatus.paid': 'paid',
  'instrument.dividendStatus.awaiting': 'awaiting payment',
  'instrument.dividendStatus.approved': 'approved',
  'instrument.dividendStatus.recommended': 'recommended',
  'instrument.dividendStatus.forecast': 'forecast',
  'instrument.periodAria': 'Chart period',
  'instrument.period.1d': '1D',
  'instrument.period.1w': '1W',
  'instrument.period.1m': '1M',
  'instrument.period.1y': '1Y',
  'instrument.period.5y': '5Y',
  'instrument.periodLabel.1d': 'today',
  'instrument.periodLabel.1w': 'this week',
  'instrument.periodLabel.1m': 'this month',
  'instrument.periodLabel.1y': 'this year',
  'instrument.periodLabel.5y': 'in 5 years',
  'instrument.period.all': 'All',
  'instrument.periodLabel.all': 'all time',
  'instrument.trading': 'Trading',
  'instrument.fundamentals': 'Fundamentals',
  'instrument.fundamentalsSource': 'T-Invest, trailing 12 months and the latest report',
  'instrument.fGroup.valuation': 'Valuation',
  'instrument.fGroup.debt': 'Debt',
  'instrument.fGroup.profitability': 'Profitability',
  'instrument.fGroup.financials': 'Trailing 12 months',
  'instrument.fGroup.dividends': 'Dividends',
  'instrument.fGroup.other': 'Other',
  'instrument.f.debt': 'Total debt',
  'instrument.f.netDebtEbitda': 'Net debt / EBITDA',
  'instrument.f.debtEquity': 'Debt / equity',
  'instrument.f.netMargin': 'Net margin',
  'instrument.f.revenue': 'Revenue',
  'instrument.f.netIncome': 'Net income',
  'instrument.f.fcf': 'Free cash flow',
  'instrument.f.dividendYield': 'Dividend yield',
  'instrument.f.payout': 'Payout ratio',
  'instrument.f.beta': 'Beta',
  'instrument.f.range52w': '52-week low — high',
  'instrument.f.shares': 'Shares outstanding',
  'instrument.chartFailed': 'Could not load the chart',
  'instrument.noChart': 'No data for the chart',
  'instrument.newsFailed': 'Could not load the news',
  'instrument.noNews': 'No news yet',
  // Heatmap (docs/heatmap/SPEC.md)
  'heatmap.title': 'Stock heatmap',
  'heatmap.modeAria': 'Which shares',
  'heatmap.mode.index': 'Index',
  'heatmap.mode.portfolio': 'My portfolio',
  'heatmap.portfolio': 'Portfolio',
  'heatmap.loadFailed': 'Could not load the heatmap',
  'heatmap.noShares': 'No shares in “{name}”',
  'heatmap.noSharesHint': 'Bonds and funds are not shown on the map',
  'heatmap.showIndex': 'Show the index',
  'heatmap.noData': 'Market data is still loading',
  'heatmap.sharePart': 'Part {value} %',
  'heatmap.turnoverShort': 'Turnover {value}',
  'heatmap.tileAria': '{ticker}, {name}, {change}',
  'heatmap.noChange': 'change unknown',
  'heatmap.plus': 'up {value}',
  'heatmap.minus': 'down {value}',
  'heatmap.mapAria': 'Heatmap, tiles: {count}',
  'heatmap.turnover': 'Turnover today',
  'heatmap.capitalization': 'Market cap',
  'heatmap.indexWeight': 'Index weight',
  'heatmap.today': 'Today',
  'heatmap.showAll': 'Show all',
  'heatmap.allTitle': 'All shares',
  'heatmap.turnoverOn': 'Turnover on {date}',
  'heatmap.updatedToday': 'Updated today at {time}',
  'heatmap.updatedOn': 'Updated {date} at {time}',
  'heatmap.share': 'Share the map',
  'heatmap.copy': 'Copy the map',
  'heatmap.copied': 'Map copied',
  'heatmap.copyFailed': 'Could not copy the map',
  'heatmap.shareFailed': 'Could not share the map',
};
